import React, { useEffect, useState } from "react";
import Switch from "@mui/material/Switch";
import { MultiSelect } from "react-multi-select-component";
import "./createPublishPreRead.css";
import {
  DatePickerComponent,
  TimePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars";

import axios from "../../../../axios";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import SuccessfullPreRead from "../create_successfullPreRead/SuccessfullPreRead";
import ResponseLoding from "../create_successfullPreRead/ResponseLoding";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

let res;
let btnColor = "#FEF2E5";
let btnTrxtColor = "#FDD9B2";

const CreatePublishPreRead = ({
  setPublish,
  prereadState,
  newPreRead,
  attach,
  attachMent,
  redirectStateData,
}) => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [lectureDate, setLectureDate] = useState();
  const [click, setClick] = useState(false);
  const [livedropdowns, setLivedropdowns] = useState([]);
  const [slistDropdown, setSlistDropdown] = useState([]);
  const [slistDropdown1, setSlistDropdown1] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  let dummyArr = [];
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [selected, setSelected] = useState([]);
  const dataArray = selected;
  const idArray = dataArray?.map((obj) => obj?.value);
  const options = slistDropdown1;
  const labelMap = new Map();
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const uniqueOptions = [];
  options.forEach((option) => {
    if (!labelMap.has(option.value)) {
      labelMap.set(option.value, true);
      uniqueOptions.push(option);
    }
  });
  useEffect(() => {
    const helper = () => {
      if (prePublishState.deadline !== "") {
        if (idArray?.length > 0) {
          setIsDisabled(false);
          btnColor = "#F77F00";
          btnTrxtColor = "#ffffff";
        } else {
          setIsDisabled(true);
          btnColor = "#FEF2E5";
          btnTrxtColor = "#FDD9B2";
        }
      } else {
        setIsDisabled(true);
        btnColor = "#FEF2E5";
        btnTrxtColor = "#FDD9B2";
      }
    };
    helper();
  });
  console.log(idArray);

  const [prePublishState, setPrePublushState] = useState({
    deadline: "",
    scheduleDate: "",
    scheduleTime: "",
    liveSession: null,
    liveSessionDate: null,
    studentList: "",
  });

  console.log(prePublishState);
  const { deadline, scheduleDate, scheduleTime, liveSession, liveSessionDate } =
    prePublishState;
  const {
    tittle,
    subjects,
    sections,
    classes,
    chapters,
    book,
    pretypes,
    description,
  } = prereadState;
  let subjectId = subjects.split(",")[1];
  let sectionId = sections.split(",")[1];
  let standarId = classes.split(",")[1];

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleChange1 = (event) => {
    setChecked1(!checked1);
  };
  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  useEffect(() => {
    const getlivesessionDropdown = async () => {
      if (!academicYearId || !timeTableSessionId) {
        toast.error(
          "These are no allocations set for your login. Please contact school admin for the assistance.",
        );
        return;
      }
      try {
        if (prePublishState?.deadline !== "") {
          const liveSession = await axios.get(
            `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${standarId}/sectionId/${sectionId}/timetableSessionId/${timeTableSessionId}/subjectId/${subjectId}/date/${lectureDate}`,
          );
          //liveSession.data.data.forEach((item) => {
          liveSession && setLivedropdowns(liveSession?.data?.data[0].lectures);
          //});
        }
      } catch (error) {
        console.log(error);
      }
    };
    getlivesessionDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureDate]);

  useEffect(() => {
    const getStudentList = async () => {
      if (!timeTableSessionId) {
        return;
      }
      try {
        const studentList = await axios.get(
          `/api/v1/school/student/getList?standardId=${standarId}&sectionId=${sectionId}&timetableSession=${timeTableSessionId}`,
        );
        dummyArr = [];
        console.log("studentList", studentList);
        studentList.data.data.forEach((obj) => {
          let res = {
            value: `${obj.id}`,
            label: `${obj.name}`,
          };
          dummyArr.push(res);
          console.log("dummyArr", dummyArr);
        });
        setSlistDropdown1(dummyArr);
        studentList && setSlistDropdown(studentList.data.data);
      } catch (error) {}
    };
    getStudentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [standarId]);

  let createPreRead = {
    standard_id: classes.split(",")[1],
    subject_id: subjects.split(",")[1],
    section_id: sections.split(",")[1],
    chapter_id: chapters,
    book_id: book,
    type: pretypes.split(",")[1],
    academic_session_id: academicSessionId,
    timetable_session_id: timeTableSessionId,
    teacher_id: Teacher_Json,
    status: "published",
    description,
    name: tittle,
    deadline,
    attachments: attach,
    attachments_sizeKb: Math.round(attachMent.map((file) => file.size / 1024)),
    schedule_date: scheduleDate,
    schedule_time: scheduleTime,
    add_to_live_session: {
      lecture_id: liveSession,
      date: liveSessionDate,
    },
  };
  console.log(createPreRead);

  const handelPublish = async (e) => {
    if (attach) {
      const formData = new FormData();
      formData.append("name", attach.name);
      formData.append("uploadPreReadAttachment", attach);
      try {
        const res = await axios.post(
          `/api/v1/preRead/uploadAttachment/teacherId/${Teacher_Json}?isForDropdown=true`,
          formData,
        );
        createPreRead.attachments = res.data.data;
        console.log(res);
      } catch (error) {}
    }
  };
  const helper = async () => {
    try {
      res = await axios.post(`/api/v1/homework/preRead/create`, createPreRead);
      res && setClick(true);
      console.log("object", res);
      if (redirectStateData !== null) {
        navigate("/liveSession", { state: redirectStateData });
      }
    } catch (error) {}
    try {
      let body = {
        teacher_id: Teacher_Json,
        student_id: idArray,
        // status: "published",
        status: "pending",
        deadline,
      };
      console.log("student_id", body);
      let res1 = await axios.post(
        `/api/v1/homework/preRead/${res?.data?.data?.id}/studentPreRead/create`,
        body,
      );
      console.log("res1", res1);
      if (res1.status === 201) {
        setLoading(false);
        setSuccess(true);
      } else {
        setSuccess(false);
      }
    } catch (error) {
      console.log(error);
    }

    localStorage.removeItem("prereadStateLocal");
  };

  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };

  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }
  // const today = new Date(); // get today's date
  // const disablePastTimes = (date) => {
  //   return date < today; // disable times that are before today
  // };
  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadlines = prePublishState?.deadline;
  console.log(deadline);
  if (deadlines) {
    var minLiveSessionDate = new Date(deadlines);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 7);
    var maxLiveSessionDate = new Date(deadlines);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }

  return (
    <>
      <div className="publish_transprant_body">
        {!click && (
          <>
            <div className=" p-4 publish_white_containerPre ">
              <img
                alt=""
                src="/images/cross-circle3.svg"
                // src="/images/word_logo.png"
                className="subPrereadClosetBtn"
                onClick={(e) => setPublish(false)}
              />

              <h5 className="publish_header">Publish</h5>
              <div className="boxs_height col-12  publish_field_boxs">
                {newPreRead.subject_name}
              </div>
              <div className="boxs_height col-12 publish_field_boxs">
                {newPreRead.standard_name}
              </div>
              <div className="boxs_height col-12 publish_field_boxs">
                {newPreRead.section_name}
              </div>
              <div className=" col-12 m-0 p-0 px-2 EnterDeadlinePreread">
                <DateTimePickerComponent
                  min={minDateTime}
                  showClearButton={false}
                  isDateDisabled={disablePastDates}
                  allowEdit={true}
                  placeholder="Deadline"
                  id="datepicker"
                  // value={newPreRead?.deadline}
                  onChange={(e) => {
                    setPrePublushState({
                      ...prePublishState,
                      deadline: e.target.value,
                    });
                  }}
                />
              </div>

              <div className="my-3">
                <div>
                  <MultiSelect
                    removeSelected={{ component: "" }}
                    options={uniqueOptions}
                    value={selected}
                    labelledBy="Your Custom Placeholder Here"
                    onChange={setSelected}
                    className="custom-multiselect w-100"
                  />
                </div>
              </div>
              <div className="btn_containers">
                <div className="toggle_btn">
                  <div className="schedule_btns">
                    {deadlines ? (
                      <label className=" switch p-0 m-0">
                        <DatePickerComponent
                          id="datepicker"
                          placeholder="Add to Lecture Session"
                          width={230}
                          min={minLiveSessionDate}
                          max={maxLiveSessionDate}
                          allowEdit={false}
                          onChange={(e) => {
                            setChecked1(true);
                            setLectureDate(formatDate(e.target.value));
                            console.log(typeof e.target.value);
                          }}
                        />
                      </label>
                    ) : (
                      <>
                        <label className="deadlineNotSelect">
                          Add to Lecture Session
                        </label>
                        <img
                          src="/images/calIconDow.png"
                          alt=""
                          className="calDow"
                        />
                      </>
                    )}
                  </div>
                  {checked1 && (
                    <div
                      className="schedule_box border-0 p-0"
                      style={{ width: "100%" }}
                    >
                      <select
                        className="form-select col-12 py-2 m-0"
                        id="Schedule_sesion"
                        style={
                          prePublishState.liveSession == null
                            ? { color: "#668598" }
                            : { color: "#000" }
                        }
                        onChange={(e) =>
                          setPrePublushState({
                            ...prePublishState,
                            liveSession: e.target.value,
                            liveSessionDate: convertDateFormat(
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("schdate"),
                            ),
                          })
                        }
                      >
                        <option selected>Select Lecture</option>
                        {livedropdowns?.length > 0 &&
                          livedropdowns?.map((lecture, index) => (
                            <option
                              key={index}
                              value={lecture.id}
                              schdate={lecture.date}
                            >
                              {lecture.name}, {lecture.date},{" "}
                              {convertTimeStringToAMPM(lecture.start_time)}-
                              {convertTimeStringToAMPM(lecture.end_time)}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>
                {/* {checked1 && <><div></div></>} */}
              </div>
              <div className="  publish_btn_box">
                <button
                  className="btn publish_btn"
                  // style={{
                  //   // background: `${btnColor}`,
                  //   // color: `${btnTrxtColor}`,
                  // }}
                  onClick={() => {
                    helper();
                    setLoading(true);
                  }}
                  disabled={
                    isDisabled ||
                    (checked1 &&
                      livedropdowns?.length > 0 &&
                      lectureDate &&
                      !prePublishState.liveSessionDate)
                  }
                >
                  Publish
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      {success && <SuccessfullPreRead />}
      {loading && <ResponseLoding />}
    </>
  );
};

export default CreatePublishPreRead;
